import { Module } from 'vuex-smart-module';
import LeadsActions from './actions';
import LeadsGetters from './getters';
import LeadsMutations from './mutations';
import LeadsState from './state';

export default new Module({
  state: LeadsState,
  mutations: LeadsMutations,
  actions: LeadsActions,
  getters: LeadsGetters,
});
